import { render, staticRenderFns } from "./ModalSelecionarDestinatarios.vue?vue&type=template&id=c44a3dd8"
import script from "./ModalSelecionarDestinatarios.vue?vue&type=script&lang=ts"
export * from "./ModalSelecionarDestinatarios.vue?vue&type=script&lang=ts"
import style0 from "./ModalSelecionarDestinatarios.vue?vue&type=style&index=0&id=c44a3dd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports